import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "q-pa-md" };
const _hoisted_5 = { class: "row q-col-gutter-md items-center" };
const _hoisted_6 = { class: "col-12 flex justify-end" };
const _hoisted_7 = { class: "q-pa-xs q-mt-lg" };
const _hoisted_8 = { class: "row items-center justify-between" };
const _hoisted_9 = { class: "table-caption" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { class: "table-caption" };
const _hoisted_12 = ["href"];
const _hoisted_13 = { class: "row" };
const _hoisted_14 = {
    key: 0,
    class: "col-12 col-md-6"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_BukenRoomList = _resolveComponent("BukenRoomList");
    const _component_ShomeiListTable = _resolveComponent("ShomeiListTable");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    { itemId: _ctx.PageID.shomeiList }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        (_ctx.isVisibleRange)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: "q-pa-md",
                                innerHTML: _ctx.htmlRange.value
                            }, null, 8, _hoisted_3))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, [
                                    _createVNode(_component_q_btn, {
                                        size: "lg",
                                        label: "新規発行",
                                        color: "green-7",
                                        "icon-right": "navigate_next",
                                        onClick: _ctx.onClick
                                    }, null, 8, ["onClick"])
                                ])
                            ])
                        ]),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _createElementVNode("div", _hoisted_9, [
                                            _cache[1] || (_cache[1] = _createTextVNode("各種証明書の申請内容を確認する場合は、", -1)),
                                            (_ctx.myPageStore.isMultipleKeiyaku)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "該当する部屋を"))
                                                : _createCommentVNode("", true),
                                            _cache[2] || (_cache[2] = _createTextVNode("一覧から選択してください。", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _cache[3] || (_cache[3] = _createTextVNode("※書類配送の追跡は", -1)),
                                            _createElementVNode("a", {
                                                href: _ctx.tuisekiLink,
                                                target: "_blank",
                                                rel: "noopener noreferrer"
                                            }, "こちら", 8, _hoisted_12)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_13, [
                                        (_ctx.myPageStore.isMultipleKeiyaku)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                _createVNode(_component_BukenRoomList)
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_ShomeiListTable)
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    class: "btn-route col-8 col-md-4",
                                    label: "トップに戻る",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$router.push({ name: 'top' })))
                                })
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
